import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import { buttonRed, darkcolor, dialogEditEvent, pcolor, rcolor } from "../../style2";

export default function ViewEvent({
  open,
  handleClose,
  eventType,
  eventData
}) {

  const [eventDataDialog, setEventDataDialog] = useState([]);
  const [eventArchive, setEventArchive] = useState([]);
  const ls = new AccessLocalStorage();
  useEffect(() => {
    setEventArchive([]);
    setEventDataDialog(eventData);

    if (eventType === "Splints and Equipments" && eventData.id != undefined) {
      const authTokens = localStorage.getItem("authTokens");
      let token;

      if (authTokens) {
        const parsedAuthTokens = JSON.parse(authTokens);
        token = parsedAuthTokens?.accessToken;
      }
      if (!token) {
        return;
      }
      fetch(
        `${getApiUrl()}${process.env.REACT_APP_GET_SPLINTSANDEQUIPMENTS
        }/getEventHistory/${ls.getCurrentPatientId()}/${"4E67778A-8FB4-4E0F-B4E0-40DB7A979C78"}/${eventData.id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          //console.log(data);
          setEventArchive(data);
        })
        .catch((err) => {
          console.log(err.message || "An error occurred.");
        })
    }
  }, [eventData]);

  const [showAccordion, setShowAccordion] = useState(false);
  const eventDate = new Date()
  const renderSplintStatusName = (id) => {
    switch (id) {
      case 1:
        return <Typography>Planned</Typography>;
      case 2:
        return <Typography>Referred</Typography>;
      case 3:
        return <Typography>Measured</Typography>;
      case 4:
        return <Typography>Waiting</Typography>;
      case 5:
        return <Typography>Supplied</Typography>;
      case 6:
        return <Typography>Using</Typography>;
      case 7:
        return <Typography>Outgrown</Typography>;
      default:
        return "";
    }
  }
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box sx={dialogEditEvent}>

        <DialogTitle>
          <Typography sx={{ textTransform: "Capitalize", fontSize: "18px", color: rcolor, fontWeight: "bold", textAlign: "left" }}>{eventType}</Typography>
        </DialogTitle>

        <Box m={2} />
        <DialogContent style={{ height: "380px" }}>
          <Grid container  >
            <Grid item xs={12}>
              <label style={{ color: pcolor, fontSize: "15px", fontWeight: "bold" }}>{
                eventType === "Appointment"
                  ? "Appointment"
                  : eventType === "Todo"
                    ? "Name"
                    : eventType === "School event"
                      ? "Event"
                      : eventType
              }</label>
              <Box style={{ marginTop: "6px", marginBottom: "10px", color: darkcolor }}>
                <Typography>{
                  eventDataDialog.title
                }</Typography>
              </Box>
            </Grid>

            {eventDataDialog.description !== null && eventDataDialog.description !== undefined &&
              eventDataDialog.description.length > 0 ?
              <Grid item xs={12} >
                <Box m={1} />
                <label style={{ color: pcolor, fontSize: "15px", fontWeight: "bold" }}>Details</label>
                <Box style={{ marginTop: "6px", marginBottom: "6px", color: darkcolor }}><Typography>{eventDataDialog.description}</Typography></Box>
              </Grid>

              : null}
          </Grid>
          <Grid container item xs={12}>
            <Box m={1} />
            <Grid item xs={12}>
              <label style={{ color: pcolor, fontSize: "15px", fontWeight: "bold" }}>
                Date
              </label>

              <Box style={{ marginTop: "6px", color: darkcolor }}>
                <Typography>{dayjs(eventDataDialog.startDate).format("DD.MM.YYYY")} {"    " + dayjs(eventDataDialog.startDate).format("h:mm A")}{eventDataDialog.endDate != null ? " - " +
                  dayjs(eventDataDialog.endDate).format("h:mm A") : null}</Typography>
              </Box>
              <Box m={1} />
            </Grid>
          </Grid>
          {
            eventType === "Splints and Equipments" ? <>
              <Box m={1} />
              <label style={{ color: pcolor, fontSize: "15px", fontWeight: "bold" }}>
                Status
              </label>
              <Box m={1} /></> : null}
          {eventArchive
            .sort((a, b) => a.SplintsEquipmentStatusId - b.SplintsEquipmentStatusId)
            .map((ea, index) => (
              <Grid key={ea.id} container xs={12} sm={12} md={12} lg={12} xl={12} spacing={2} style={{ marginBottom: "8px" }}>
                <Grid item xs={6}>
                  {renderSplintStatusName(ea.splintsEquipmentStatusId)}
                </Grid>
                <Grid item xs={6} direction="column">
                  <Typography >{dayjs(ea.startDate).format("DD.MM.YYYY h:mm A")}</Typography>
                </Grid>
              </Grid>
            ))}
          {
            eventType === "Splints and Equipments" ?
              <Grid container xs={12} sm={12} md={12} lg={12} xl={12} spacing={2} style={{ color: pcolor }}>
                <Grid item xs={6} style={{ fontWeight: "normal" }}>
                  {renderSplintStatusName(eventData.splintsEquipmentStatusId)}
                </Grid>
                <Grid item xs={6} direction="column" >
                  <Typography style={{ color: pcolor }}>{dayjs(eventData.startDate).format("DD.MM.YYYY h:mm A")}</Typography>
                </Grid>
              </Grid> : null
          }
        </DialogContent>
        <Box m={2} />
        <DialogActions>
          <Grid container alignItems="center">
            <Grid item xs={12} container justifyContent="center">
              <Button sx={buttonRed} onClick={handleClose}>
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
